import React from "react";
import RelativeTime from "components/RelativeTime";
import { buildRegistrationTimeline } from "utilities/registrationTimeline";

/**
 * SOUND-643 — the registration's status history as a dot rail.
 *
 * Deliberately the same construction as components/Tickets/ActivityTimeline:
 * `grid-cols-[16px_1fr]`, a category-coloured dot ringed against the card, a
 * connecting border to the next entry, then one line of text with actor and
 * relative time. A status change should read identically whether it happened on
 * a ticket or on a registration.
 *
 * Entry building lives in utilities/registrationTimeline.js, which has tests.
 */
export default function RegistrationTimeline({ application }) {
  const entries = buildRegistrationTimeline(application);

  if (entries.length === 0) {
    return <p className="text-xs text-muted-foreground">No activity yet.</p>;
  }

  return (
    <div className="flex flex-col">
      {entries.map((entry, i) => {
        const isLast = i === entries.length - 1;
        return (
          <div key={entry.key} className="grid grid-cols-[16px_1fr] gap-2.5">
            {/* rail */}
            <div className="relative flex justify-center">
              <span
                className={`mt-1 h-2 w-2 rounded-full ${entry.dot} ring-2 ring-card`}
                style={{ zIndex: 1 }}
                aria-hidden="true"
              />
              {!isLast && (
                <span
                  className="absolute left-1/2 top-2 -translate-x-1/2 border-l border-border"
                  style={{ bottom: "-10px" }}
                />
              )}
            </div>

            {/* text */}
            <div className={isLast ? "" : "pb-3.5"}>
              <div className="text-xs text-foreground">{entry.text}</div>
              {entry.reason && (
                <div className="mt-0.5 text-xs italic text-muted-foreground">
                  “{entry.reason}”
                </div>
              )}
              {(entry.actor || entry.at) && (
                <div className="mt-0.5 text-[11px] text-muted-foreground">
                  {entry.actor ? `${entry.actor} · ` : ""}
                  {entry.at && <RelativeTime value={entry.at} />}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
